import React from 'react';
import { Link } from 'react-router-dom';
import './SpaStickyButton.css';

const SpaStickyButton = () => {
  return (
    <Link to="/spa" className="spa-sticky-button">
      <div className="spa-button-content">
        {/* <span className="spa-icon">🧖</span> */}
        {/* <span className="spa-text">Explore Our Spa</span> */}
        <img className='ojas' src='/assets/ojas.png' alt='' />
        <img className='ojas1' src='/assets/ojas1.png' alt='' />
      </div>
    </Link>
  );
};

export default SpaStickyButton;